import { adoptAccessToken, api, ApiError } from '../../shared/api/http'

export type AuthenticatedUser = { login: string; fullName: string }
type AuthenticationResponse = { accessToken: string; user: AuthenticatedUser }

function adopt(response: AuthenticationResponse) {
  adoptAccessToken(response.accessToken)
  return response.user
}

export async function restoreSession() {
  for (let attempt = 0; attempt < 3; attempt += 1) {
    try {
      return adopt(await api<AuthenticationResponse>('/auth/restore', { method: 'POST' }))
    } catch (error) {
      const rejectedSession = error instanceof ApiError && error.status >= 400 && error.status < 500
      if (rejectedSession || attempt === 2) {
        adoptAccessToken(null)
        return null
      }
      await new Promise((resolve) => setTimeout(resolve, 350 * (attempt + 1)))
    }
  }
  return null
}

export async function login(loginValue: string, password: string, rememberMe: boolean, secondFactorCode?: string) {
  return adopt(await api<AuthenticationResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ login: loginValue, password, rememberMe, secondFactorCode }),
  }))
}

export type Registration = { login:string;fullName:string;birthDate:string;email:string;phone:string;password:string;passwordConfirmation:string;language:string }
export async function register(data:Registration){const {language,...identity}=data;return adopt(await api<AuthenticationResponse>('/auth/register',{method:'POST',body:JSON.stringify({...identity,acceptedTerms:true,termsVersion:'draft-2026-08-09',privacyVersion:'draft-2026-08-09',documentLanguage:language})}))}
export const requestPasswordReset=(login:string,channel:string)=>api<null>('/identity/password-reset/request',{method:'POST',body:JSON.stringify({login,channel})})
export const resetPassword=(login:string,channel:string,code:string,newPassword:string,passwordConfirmation:string)=>api<null>('/identity/password-reset/confirm',{method:'POST',body:JSON.stringify({login,channel,code,newPassword,passwordConfirmation})})

export async function logout() {
  try {
    await api<null>('/auth/logout', { method: 'POST' })
  } finally {
    adoptAccessToken(null)
  }
}
